import { EntInitialFilter } from "../../../models/filters/initialFilter";
import { EntPositions } from "../../../models/handBooks/positions";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const positionsApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getPositionsList: builder.query<ResponseDataGet<EntPositions>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.positions }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getPositionsById: builder.query<ResponseDataGet<EntPositions>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.positions }/${ id }`,
		method: 'GET'
	  })
	}),
	addPositions: builder.mutation<ResponseDataGet<EntPositions>, EntPositions>({
	  query: (body) => ({
		url: `${ Paths.handbooks.positions }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editPositions: builder.mutation<ResponseDataGet<EntPositions>, EntPositions>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.positions }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deletePositions: builder.mutation<ResponseDataGet<EntPositions>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.positions }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddPositionsMutation,
  useDeletePositionsMutation,
  useEditPositionsMutation,
  useLazyGetPositionsListQuery
} = positionsApi;
